<template>
  <div class="col-lg-12 col-12 mx-auto pt-2 px-2 d-flex main-image-wrapper home-banner">
    <b-carousel
      v-if="banners.length"
      id="home-banner-carousel"
      :interval="3000"
      controls
      fade
      class="home-banner__carousel w-100"
      style="width: 100%; height: 100%;"
    >
      <b-carousel-slide
        v-for="banner in banners"
        :key="banner.id"
        :img-src="banner.image"
      />
    </b-carousel>
  </div>
</template>

<script>
const MOCK_BANNERS = [
  { id: 'mock-banner-1', image: 'https://storage.googleapis.com/spacetech2/melonzeed/dailyBonus30%25.webp' },
  { id: 'mock-banner-2', image: 'https://storage.googleapis.com/spacetech2/melonzeed/dailyBonus100%25.webp' },
  { id: 'mock-banner-3', image: 'https://storage.googleapis.com/spacetech2/melonzeed/dailyBonus200%25.webp' },
  { id: 'mock-banner-4', image: 'https://storage.googleapis.com/spacetech2/melonzeed/slot20%25.webp' },
  { id: 'mock-banner-5', image: 'https://storage.googleapis.com/spacetech2/melonzeed/loss5%25.webp' },
  { id: 'mock-banner-6', image: 'https://storage.googleapis.com/spacetech2/melonzeed/regularDeposit5%25.webp' },
];

export default {
  data() {
    return {
      banners: [],
    };
  },
  mounted() {
    this.fetchBanners();
  },
  methods: {
    async fetchBanners() {
      try {
        const res = await axios.get('/banners');
        const banners = this.normalizeBanners(res.data);
        this.banners = banners.length ? banners : MOCK_BANNERS;
      } catch (error) {
        this.banners = MOCK_BANNERS;
      }
    },
    normalizeBanners(payload) {
      const raw = Array.isArray(payload)
        ? payload
        : (Array.isArray(payload?.data) ? payload.data : []);

      return raw
        .map((banner, index) => ({
          id: banner?.id ?? `banner-${index}`,
          image: typeof banner?.image === 'string' ? banner.image.trim() : '',
        }))
        .filter((banner) => banner.image);
    },
  },
};
</script>

<style scoped>
.home-banner {
  max-width: 100%;
  overflow: hidden;
}

.home-banner ::v-deep .carousel,
.home-banner ::v-deep .carousel-inner,
.home-banner ::v-deep .carousel-item {
  background: #fff !important;
  border-radius: 0 !important;
}

.home-banner ::v-deep .carousel-item img,
.home-banner ::v-deep img {
  width: 100%;
  border-radius: 0 !important;
  display: block;
}
</style>
